<template>
	<div class="main-containter" id="top" v-title data-title="和华利盛">
		<FHeader :checkId="27"></FHeader>
		<FOtherBanner :name1="'资讯动态'" :name2="'Information Dynamics'"></FOtherBanner>
		<!-- <FTitle></FTitle> -->
		<article style="height: 100%;">
			<div style="padding-left: 18%;padding-top: 20px;">
				<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>资讯动态</el-breadcrumb-item>
				<el-breadcrumb-item style="color:black">经典案例</el-breadcrumb-item>
			</el-breadcrumb>
			</div>
			<div style="width: 64%;padding: 30px 18%;margin-top:50px;">
				<div style="text-align: center;">
					<div style="font-size: 26px;font-weight: 900;color: #98273A;">经典案例</div>
					<div style="padding-top: 5px;font-size: 14px;color: #98273A;">Classic Cases</div>
				</div>
				<div :style="{'padding-top':'30px','height':parseInt(((tableList.length+1)/2)*240)+'px'}">
					<div :style="{float:'left',width:'calc(48% - 2px)','margin-right':index%2 != 1?'2%':'0%','margin-left':index%2 != 1?'0%':'2%',height:'200px','margin-top':'25px','border':'1px solid #D7D7D7'}" v-for="(item,index) in tableList" :key="index">
						<div class="classicCasesTitle" style="color: #333333;font-weight: 600;font-size: 18px;padding: 30px 25px 20px 25px;cursor: pointer;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;cursor:pointer;" @click="toDetail(item,index)">{{item.title}}</div>
						<div style="color: #595959;font-size: 14px;margin-left: 25px;margin-right: 25px;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;line-height: 24px;-webkit-box-orient: vertical;margin-bottom: 20px;cursor:pointer;"  @click="toDetail(item,index)">{{item.description}}</div>
						<div style="font-size: 14px;margin-right: 25px;margin-left: 25px;font-weight: 900;color: #AAAAAA;padding-top: 5px;">
							<div style="float: left;color: #98273A;font-size: 18px;">{{item.publish.substring(0,10)}}</div>
							<img   @click="toDetail(item,index)" style="float: right;transform: rotate(-90deg);width: 20px;height: 20px;border: 1px solid;border-radius: 50px;padding: 6px;cursor:pointer;" src="../../assets/fImage/xiangyoujiantou.svg">
						</div>
					</div>
				</div>
				<el-pagination
					background
					layout="prev, pager, next, jumper"
					:page-size="10"
					:total="total"
					@current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</article>
		<Footer></Footer>
	</div>
</template>

<script>
	import FHeader from "../../components/f/FHeader.vue"
	import FOtherBanner from "../../components/f/FOtherBanner.vue"
	import Footer from "../../components/f/Footer.vue"

	import {query} from "@/api/article";
	export default {
		name: "Index",
		components: {
			FHeader,
			FOtherBanner,
			Footer
		},
		data() {
			return {
				tableList: [],
				total:0,
				pageNo: 1,
			}
		},
		mounted() {
			this.list()
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		
		watch: {
		},
		methods: {
			async toDetail(item,index){
				this.$router.push(
					{
						path:'/newsDetail',
						query:{
							id:item.id,
						}
					}
				);
			},
			handleCurrentChange(page){
				this.pageNo = page
				this.list()
			},
			list() {
				let param = {
					title: '',
					channelId: 14,
					page: this.pageNo,
					pageSize: 10,
				}
				query(param).then(data => {
					this.tableList = data.data.list
					this.total = data.data.total
					// console.log("列表",this.tableData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
		}
	}
</script>
<style lang="scss" scoped="scoped">

	.classicCasesTitle:hover{
		color: rgb(152, 39, 58) !important;
	}
	span /deep/ .el-breadcrumb__inner{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: default !important;
	}
	span /deep/ .el-breadcrumb__inner.is-link{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: pointer !important;
	}
div /deep/ .el-pagination.is-background .btn-next:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .btn-next{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .el-pager li{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}

div /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
  /*进行修改选中项背景和字体*/
	background-color: #98273A !important;
  color:white !important;
  border-radius: 2px !important;
  font-weight: 400 !important;
  border: 1px solid #98273A !important;
}

div /deep/ .el-pagination.is-background .el-pager li:hover{
   color: #98273A !important;/*hover时候的文字颜色*/
 }
div /deep/ .el-pager li.active{
   color:#98273A !important;/*仅设置active时的文字颜色*/
 }
div /deep/ .el-pagination{
	text-align: center;
}
</style>
